// Internal editable field utility
const editable = (enabled = true) => enabled;

// Common presets
const EDITABLE = editable(true);
const NON_EDITABLE = editable(false);

// Default editable configuration — all fields editable by default
const defaultEditable = {
  title: EDITABLE,
  title_url: EDITABLE,
  desc: EDITABLE,
  tags: EDITABLE,
  team: EDITABLE,
  agency: EDITABLE,
  agency_credits: EDITABLE,
  ctype: EDITABLE,
  lang: EDITABLE,
  category: EDITABLE,
  subcategory: EDITABLE,
  production_type: EDITABLE,
  expiry: EDITABLE,
  is_short: EDITABLE,
  is_campaign: EDITABLE,
  landscapeThumb: EDITABLE,
  socialThumb: EDITABLE,
  posterThumb: EDITABLE,
  portraitThumb: EDITABLE,
  podcastThumb: EDITABLE,
  premiereThumb: EDITABLE,
  premiereVThumb: EDITABLE,
  youtube_id: EDITABLE,
  parentid: EDITABLE,
  creditors: EDITABLE,
  contributors: EDITABLE,
  denmark: EDITABLE,
  social_publish_destination: EDITABLE,
  social_publish_page: EDITABLE,
};

// Utility to override editable defaults
const withOverrides = (
  overrides: Partial<typeof defaultEditable>
): typeof defaultEditable => ({
  ...defaultEditable,
  ...overrides,
});

// Media type-specific editable maps
const editableFeatureMap = {
  chapter: withOverrides({
    // title: NON_EDITABLE,
    team: NON_EDITABLE,

    agency: NON_EDITABLE,
    lang: NON_EDITABLE,
    expiry: NON_EDITABLE,
    parentid: EDITABLE,
    // creditors: NON_EDITABLE,
    // contributors: NON_EDITABLE,
  }),
  clone: withOverrides({
    agency: NON_EDITABLE,
    agency_credits: EDITABLE,
    expiry: EDITABLE,
    parentid: EDITABLE,
    creditors: EDITABLE,
    youtube_id: EDITABLE,
    production_type: EDITABLE,
    lang: EDITABLE,
    contributors: EDITABLE,
  }),
} as const;

export type MediaEditableFeatureMapKey = keyof typeof editableFeatureMap;
export type MediaEditableFeatures = typeof defaultEditable;

// Public React hook to access editable config
export const MediaEditableConfig = (
  type: MediaEditableFeatureMapKey
): MediaEditableFeatures => {
  return editableFeatureMap[type] ?? defaultEditable;
};
